import React from 'react';
import { createPortal } from 'react-dom';
import '../../assets/styles/infrastructure_leasing_modal.scss';

function str(v) {
  if (v == null) return '';
  return String(v).trim();
}

/**
 * Single popup: seller chooses Accept deal or Reject deal (then opens the corresponding detail modal).
 */
export default function InfrastructureLeasingRespondChoiceModal({
  open,
  onClose,
  listingTitle,
  buyerName,
  onChooseAccept,
  onChooseReject,
}) {
  if (!open) return null;

  const modalUi = (
    <div className="ile-modal-root">
      <div className="ile-modal-overlay" onClick={onClose} role="presentation">
        <div
          className="ile-modal-panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby="ile-respond-choice-title"
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: 420 }}
        >
          <div className="ile-modal-panel__header">
            <button type="button" className="ile-modal-panel__close" onClick={onClose} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
            <h2 className="ile-modal-panel__title" id="ile-respond-choice-title">
              Respond to enquiry
            </h2>
            <p className="ile-modal-panel__subtitle">
              {str(listingTitle) || 'Listing'} · {str(buyerName) || 'Buyer'}
            </p>
          </div>

          <div className="ile-modal-panel__body">
            <p className="small text-muted mb-3 mb-md-4">
              Select whether to accept this deal (you will enter agreement details next) or reject it (with a reason).
            </p>
            <div className="d-grid gap-2">
              <button type="button" className="btn btn-success w-100 py-2" onClick={onChooseAccept}>
                Accept deal
              </button>
              <button type="button" className="btn btn-outline-danger w-100 py-2" onClick={onChooseReject}>
                Reject deal
              </button>
            </div>
          </div>

          <div className="ile-modal-panel__footer border-0 pt-0">
            <button type="button" className="btn btn-outline-secondary btn-sm w-100" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(modalUi, document.body);
  }
  return modalUi;
}
